module.exports = __webpack_public_path__ + "img/appAsset-brand--axteroidDark.4c648838.svg";